// src/components/direct-feedback/direct-feedback.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment DirectFeedbackCallToActionFragment on DirectFeedbackCallToAction {\n    callToAction {\n      ... on UITertiaryButton {\n        icon {\n          id\n          size\n          description\n          token\n        }\n        primary\n        analytics {\n          linkName\n          referrerId\n        }\n        egdsElementId\n      }\n    }\n    promptId\n    contextValues {\n      key\n      value\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  query DirectFeedbackCallToActionQuery(\n    $context: ContextInput!\n    $activityId: String!\n    $destination: ActivityDestinationInput\n    $dateRange: ActivityDateRangeInput\n  ) {\n    activityInfo(context: $context, activityId: $activityId, destination: $destination, dateRange: $dateRange) {\n      directFeedbackLink {\n        feedbackFormAction {\n          ...DirectFeedbackCallToActionFragment\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
import React2 from "react";
import { gql as gql2, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing, UitkSpacingHr } from "uitk-react-spacing";
// src/components/direct-feedback/__private/__fragments/direct-feedback-call-to-action.tsx
import React, { useCallback } from "react";
import { gql } from "@apollo/client";
import { useDialog } from "@shared-ui/dialog-context";
import { DirectFeedbackDialog } from "@shared-ui/retail-customer-direct-feedback";
import { UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
var __Fragment = gql(_templateObject());
var DirectFeedbackCallToAction = function (param) {
  var data = param.data;
  var _callToAction, _callToAction1, _ctaIcon, _ctaIcon1, _ctaIcon2, _ctaIcon3;
  var promptId = data.promptId,
    contextValues = data.contextValues,
    callToAction = data.callToAction;
  var _useDialog = _sliced_to_array(useDialog(promptId, "cdfPromptDialog"), 2),
    dialogActions = _useDialog[1];
  var openDialog = dialogActions.openDialog;
  var handleOnClick = useCallback(function () {
    openDialog();
  }, [openDialog]);
  if (callToAction.__typename !== "UITertiaryButton") {
    return null;
  }
  var ctaText = (_callToAction = callToAction) === null || _callToAction === void 0 ? void 0 : _callToAction.primary;
  var ctaIcon = (_callToAction1 = callToAction) === null || _callToAction1 === void 0 ? void 0 : _callToAction1.icon;
  var callToActionButton = /* @__PURE__ */React.createElement(UitkTertiaryButton, {
    onClick: handleOnClick
  }, /* @__PURE__ */React.createElement(UitkIcon, {
    name: ((_ctaIcon = ctaIcon) === null || _ctaIcon === void 0 ? void 0 : _ctaIcon.id) || "",
    key: (_ctaIcon1 = ctaIcon) === null || _ctaIcon1 === void 0 ? void 0 : _ctaIcon1.id,
    size: ((_ctaIcon2 = ctaIcon) === null || _ctaIcon2 === void 0 ? void 0 : _ctaIcon2.size) && UitkIconSize[ctaIcon.size],
    description: ((_ctaIcon3 = ctaIcon) === null || _ctaIcon3 === void 0 ? void 0 : _ctaIcon3.description) || ""
  }), ctaText);
  return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(UitkLayoutFlex, {
    justifyContent: "center"
  }, /* @__PURE__ */React.createElement(UitkLayoutFlexItem, null, callToActionButton)), /* @__PURE__ */React.createElement(DirectFeedbackDialog, {
    "data-stid": "direct-feedback-dialog",
    contextValues: contextValues,
    inputs: {
      promptId: promptId
    },
    dialogQueryId: promptId
  }));
};
DirectFeedbackCallToAction.fragment = __Fragment;
DirectFeedbackCallToAction.displayName = "DirectFeedbackCallToAction";
// src/components/direct-feedback/direct-feedback.tsx
var __Query = gql2(_templateObject1(), DirectFeedbackCallToAction.fragment);
var DirectFeedback = function (param) {
  var inputs = param.inputs,
    skipSsr = param.skipSsr;
  var _data_activityInfo_directFeedbackLink;
  var context = useBexApi().context;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      context: {
        useApq: true
      },
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  if (loading) {
    return /* @__PURE__ */React2.createElement(UitkLayoutFlex2, {
      justifyContent: "center"
    }, /* @__PURE__ */React2.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React2.createElement(UitkLineSkeleton, null)));
  }
  if (error || !data) {
    return null;
  }
  var feedbackFormAction = (_data_activityInfo_directFeedbackLink = data.activityInfo.directFeedbackLink) === null || _data_activityInfo_directFeedbackLink === void 0 ? void 0 : _data_activityInfo_directFeedbackLink.feedbackFormAction;
  if (!feedbackFormAction) {
    return null;
  }
  return /* @__PURE__ */React2.createElement(React2.Fragment, null, /* @__PURE__ */React2.createElement(UitkSpacing, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React2.createElement(DirectFeedbackCallToAction, {
    data: feedbackFormAction
  })), /* @__PURE__ */React2.createElement(UitkSpacingHr, {
    blockMargin: "two"
  }));
};
DirectFeedback.displayName = "sharedui-DirectFeedback";
export { DirectFeedback };